<template>

    <Toast/>

    <MenuSiCompact/>

    <div class="px-6 surface-overlay relative">

        <ul class="list-none py-2 px-0 m-0 flex align-items-center font-medium overflow-x-auto w-full">
            <li class="pr-3"><a @click="processHome" class="cursor-pointer"><i class="pi pi-home text-text-900"></i></a>
            </li>
            <li class="px-2"><i class="pi pi-angle-right text-900"></i></li>
            <li class="px-2"><a class="cursor-pointer text-900 white-space-nowrap">Help</a></li>
            <li class="px-2"><i class="pi pi-angle-right text-900"></i></li>
            <li class="px-2"><a class="cursor-pointer text-900 white-space-nowrap">Getting Started</a></li>
        </ul>

        <div style="height: 8px;"></div>

        <div class="grid">
            <div class="col-12">
                <span>
                    Welcome! You now have the tools to Plan, Track, and Achieve your financial freedom goals. Follow the steps below to get started on building a resilient portfolio that grows
your passive income year after year.
                </span>
            </div>
        </div>

        <div class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <div style="height: 20px;"></div>

                    <div class="flex flex-column gap-2">
                        <div class="field flex align-items-center gap-2 mb-4">
                            <InputSwitch v-model="skipWelcome" @change="onShowWelcomeChange"/>

                            <span class="text-900 font-medium line-height-1 m-0">
                                Skip this page next time
                            </span>
                        </div>


                        <div class="field">
                        <span>
                            <strong>Step 1:</strong>
                            Take the Simply Investing Course to learn everything about dividend investing, click on
                             <a href="#" @click.prevent="processCourse">Course</a>
                        </span>
                        </div>

                        <div class="field">
                        <span>
                            <strong>Step 2:</strong>
                            Use our web application (Stock Research Platform) to start building your portfolio,
                            begin by watching the Overview Video below
                        </span>
                        </div>

                        <div class="field">
                        <span>
                            <strong>Step 3:</strong>
                            Join our Simply Investing LinkedIn Group to connect with our community and ask questions,
                            click on
                            <a href="#" @click.prevent="processCommunity">Community</a>
                        </span>
                        </div>

                        <div class="field flex justify-content-center">
                            <iframe
                                width="768"
                                height="432"
                                src="https://www.youtube.com/embed/-xIMP0y5iIY?si=f7SzxGCjbWTTQ1or"
                                frameborder="0"
                                allow="autoplay; fullscreen; picture-in-picture; clipboard-write"
                                title="893379528-lesson1">
                            </iframe>
                        </div>

                    </div>

                </div>
            </div>
        </div>

    </div>

    <SiFooter/>

</template>

<script>
import {useUserStore} from "@/stores/UserStore";
import UserService from "@/service/UserService";
import CompanyService from "@/service/CompanyService";
import SiFooter from "@/components/heading/authentication/SiFooter.vue";
import userService from "@/service/UserService";
import MenuSiCompact from "@/components/simodule/MenuSiCompact.vue";

export default {
    components: {
        MenuSiCompact,
        SiFooter
    },
    setup() {
        const userStore = useUserStore()

        return {
            userStore
        }
    },
    async mounted() {
        document.title = "Simply Investing"; // Update the browser tab title
        this.setFavicon("images/blocks/logos/favicon.simplyinvesting.96x96.png");

        try {
            // Attempt to get user data
            const userData = await UserService.getUser(this.userStore.user.id);
            this.profile = userData.data;
            console.log("[Help][mounted] Data = ", userData);
            console.log("[Help][mounted] this.profile = ", this.profile);
        } catch (e) {
            console.error("[Help][mounted] Error fetching user data = ", e);
            this.userStore.clearUser();
            // this.$router.push("login");
            this.$router.replace('/siLogin');
            return;
        }

        try {
            const [userConfigData] = await Promise.all([
                UserService.getUserConfig(this.userStore.user.id)
            ]);

            this.userConfiguration = userConfigData.data;

            if (this.userConfiguration.showWelcome === 'Y') {
                this.skipWelcome = false;
            } else {
                this.skipWelcome = true;
            }

            console.log("[Help][mounted] userConfigData.data = ", userConfigData.data);
        } catch (e) {
            console.error("[Help][mounted] Could not find user config for user = ", this.userStore.user.id);

            if (e.response && e.response.status === 401) {
                console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                // this.$router.push('/siLogin'); // Redirect to the specified login route
                this.$router.replace('/siLogin');
            } else {
                // Handle other errors (e.g., network issues)
                this.userStore.clearUser();
                // this.$router.push('login'); // This is your existing fallback redirect
                this.$router.replace('/siLogin');
            }
            return;
        }

        try {
            const [companyConfigData] = await Promise.all([
                CompanyService.getCompanyConfiguration(this.profile.companyId)
            ]);

            this.companyConfiguration = companyConfigData.data;
            console.log("[Help][mounted] companyConfigData.data = ", companyConfigData.data);

        } catch (e) {
            console.error("[Help][mounted] Error fetching additional data = ", e);

            if (e.response && e.response.status === 401) {
                console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                // this.$router.push('/siLogin'); // Redirect to the specified login route
                this.$router.replace('/siLogin');
            } else {
                // Handle other errors (e.g., network issues)
                this.userStore.clearUser();
                // this.$router.push('login'); // This is your existing fallback redirect
                this.$router.replace('/siLogin');
            }
            return;
        }

        console.log("[Help][mounted] this.userConfiguration = ", this.userConfiguration);
        console.log("[Help][mounted] this.companyConfiguration = ", this.companyConfiguration);
    },
    data() {

        return {
            skipWelcome: true,
            profile: {},
            companyConfiguration: {},
            regionTypes: [
                {name: 'United Kingdom', code: 'UK'},
                {name: 'South Africa', code: 'ZA'},
                {name: 'Canada', code: 'CA'},
                {name: 'United States', code: 'US'},
                {name: 'India', code: 'IN'}
            ],
            accountTypes: [
                {name: 'Healthcare Practitioner', code: 'H'},
                {name: 'Financial Advisor', code: 'F'},
                {name: 'Small Business', code: 'S'}
            ],
            confirmationTypes: [
                {name: 'Yes', code: 'Y'},
                {name: 'No', code: 'N'}
            ]
        }
    },
    methods: {
        closeAllMenus() {
            document.body.click(); // triggers hideOnOutsideClick

            document.querySelectorAll('.p-component-overlay, .p-menu-overlay, .p-overlay, .p-tieredmenu-overlay')
                .forEach(el => el.remove());
        },
        safeNavigate(target) {
            this.closeAllMenus();
            setTimeout(() => {
                this.$router.push(target);
            }, 0);
        },
        processHome() {
            console.log("[MenuConfiguration][processHome] Beginning.");
            this.closeAllMenus();
            this.safeNavigate('/siHome');
        },
        processCourse() {
            // window.location.href = "/#/siCourse";
            const current = window.location.hash;
            if (current === "#/siCourse") {
                window.location.reload();
            } else {
                window.location.href = "/#/siCourse";
            }
        },
        processCommunity() {
            window.open("https://www.linkedin.com/groups/14562007/", '_blank');
        },
        callOverview() {
            this.$router.push("siOverview");
        },
        setFavicon(url) {
            // Check if a <link rel="icon"> tag already exists
            let faviconLink = document.querySelector("link[rel='icon']");

            if (!faviconLink) {
                // Create a new <link> element if one doesn't exist
                faviconLink = document.createElement("link");
                faviconLink.rel = "icon";
                document.head.appendChild(faviconLink);
            }

            // Update the favicon URL
            faviconLink.href = url;
        },
        async onShowWelcomeChange() {

            try {
                if (this.skipWelcome === true) {
                    this.userConfiguration.showWelcome = 'N';
                } else {
                    this.userConfiguration.showWelcome = 'Y';
                }

                console.log('[Help][onShowWelcomeChange][Before Update] this.userConfiguration = ', this.userConfiguration);
                const response = await userService.updateUserConfig(this.userStore.user.id, this.userConfiguration);
                console.log('[Help][onShowWelcomeChange] Response = ', response);

                try {
                    const [userConfigData] = await Promise.all([
                        UserService.getUserConfig(this.userStore.user.id)
                    ]);

                    this.userConfiguration = userConfigData.data;

                    if (this.userConfiguration.showWelcome === 'Y') {
                        this.skipWelcome = false;
                    } else {
                        this.skipWelcome = true;
                    }

                    console.log("[Help][onShowWelcomeChange] userConfigData.data = ", userConfigData.data);
                } catch (e) {
                    console.error("[Help][onShowWelcomeChange] Could not find user config for user = ", this.userStore.user.id);

                    if (e.response && e.response.status === 401) {
                        console.log("[Help][onShowWelcomeChange] JWT token expired. Redirecting to login.");
                        // this.$router.push('/siLogin'); // Redirect to the specified login route
                        this.$router.replace('/siLogin');
                    } else {
                        // Handle other errors (e.g., network issues)
                        this.userStore.clearUser();
                        // this.$router.push('login'); // This is your existing fallback redirect
                        this.$router.replace('/siLogin');
                    }
                    return;
                }

                console.log('[Help][onShowWelcomeChange][After Update] this.userConfiguration = ', this.userConfiguration);

                this.$toast.add({
                    severity: 'success',
                    summary: 'Successful',
                    detail: 'Configuration updated',
                    life: 3000
                });

            } catch (e) {
                console.error('[Help][onShowWelcomeChange] Error:', e);

                this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to update configuration. Please try again.',
                    life: 3000
                });
            }

        }
    }
};
</script>

<style scoped>
a {
    text-decoration: none;
}
</style>
